import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  margin-right: 18px;
  align-items: center;
`;
